import { MainAppContext } from '@/index';
import { notification } from 'antd';
import { FC, useContext } from 'react';

const CustomNotification: FC<any> = () => {
  const { container } = useContext(MainAppContext);
  notification.config({
    getContainer() {
      return (container || document).querySelector('#popContainer');
    }
  });
  const [api, contextHolder] = notification.useNotification();
  window.microNotification = {
    ...api,
    destroy: notification.destroy,
    close: notification.close,
  };
  return (
    <div>
      {contextHolder}
    </div>
  );
};

export default CustomNotification;
